import { createSlice } from "@reduxjs/toolkit";

const initialDtpsSlice = {
    listLoading: true,
    actionsLoading: false,
    queryParams: null,
    error: null,
    totalCount: 0,
    entities: [],
    selectedDtp: {teste: "initial"}
}

export const callTypes = {
    list: 'list',
    select: 'select'
}

export const dtpsSlice = createSlice({
    name: 'dtps',
    initialState: initialDtpsSlice,
    reducers: {
        //
        catchError: (state, action) => {
            state.error = `${action.type}: ${action.payload.error}`;
            if (action.payload.callType === callTypes.list || action.payload.callType === callTypes.select) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        //
        startCall: (state, action) => {
            state.error = null;
            if (action.payload.callType === callTypes.list || action.payload.callType === callTypes.select) {
              state.listLoading = true;
            } else {
              state.actionsLoading = true;
            }
        },
        //
        dtpsFetched: (state, action) => {
            // if (action.payload.callType === callTypes.list) {
                const { totalCount, entities } = action.payload;
                state.listLoading = false;
                state.error = null;
                state.entities = entities;
                state.totalCount = totalCount;
                state.selectedDtp = {teste:"listDTP"};
            // }
        },

        dtpSelected: (state, action) => {
            console.log('dtpSelected');
            const selectedDtp = action.payload;
            state.listLoading = false;
            state.error = null;
            state.selectedDtp = {teste:"selectedDTP"};
        },
    }
})
